<template>
  <v-list-item @click="selezionaProdotto">
    <v-list-item-avatar>
      <v-img :src="img_url"></v-img>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{ nome[0] }}</v-list-item-title>
      <v-list-item-subtitle>{{ nome[1] }}</v-list-item-subtitle>
    </v-list-item-content>
  </v-list-item>
</template>
  
  <script>
export default {
  props: {
    prodotto: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      nome: this.prodotto.nome.split(" in "),
      img_url: process.env.VUE_APP_API_ROOT + "/avatar_img/" + this.prodotto.id,
    };
  },
  methods: {
    selezionaProdotto() {
      this.$emit("selezionato", this.prodotto.id);
    },
  },
};
</script>
  
  <style scoped>
/* Add your styles here */
</style>